import { cookies } from './cookies'

export const saveDogApplication = (application) => {
  cookies.set('dog-application', application, {
    path: '/',
    maxAge: 60 * 60 * 24 * 14,
    domain:
      window.location.host.indexOf('www') > -1
        ? window.location.host.replace('www', '')
        : null,
  })
  return Promise.resolve()
}

export const getDogApplication = () => {
  const app = cookies.get('dog-application')
  if (app) {
    return app
  }
}
